export default {"src":"/_next/static/media/solana-dark.774702e8.svg","height":19,"width":18,"blurWidth":0,"blurHeight":0};